const apiConfig = {
    baseUrl: process.env.REACT_APP_API_URL,

    timeout: 30000
};

export default apiConfig;
